const firebaseConfig = {
  apiKey: "AIzaSyAMjRKXJkrTB4wp-retM5LHrg3SOMHyWcw",
  authDomain: "fornya-firelab.firebaseapp.com",
  databaseURL: "https://fornya-firelab.firebaseio.com",
  projectId: "fornya-firelab",
  storageBucket: "fornya-firelab.appspot.com",
  messagingSenderId: "365879125284",
  appId: "1:365879125284:web:9b6a43830b331f43207fb1"
  };

  export default firebaseConfig


// WEBPACK FOOTER //
// ./src/firebaseConfig.js